const t=t=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t);export{t as isNumericalString};
